import React from 'react'
import { navigate} from 'gatsby'
import PropTypes from "prop-types"
import Image from '../Image'
import List from '../List'

import * as S from './styles'


function onClick(slug){

  if(slug.indexOf("https") > -1 || slug?.indexOf("http") > -1) {
    window.location.href = slug
    return
  }

  if(slug){
    navigate(slug)
    return
  }

}

const ListOfImages = (props) => {

  const { title, items} = props

  return (
    <S.ListOfImages>
      {title && <S.Title>{title}</S.Title>}
      {items && <List columns={4}>
        {items.map((item) => <S.ImageWrapper key={item.slug || item.image?.src} onClick={()=> onClick(item.slug)}><Image image={item.image} /></S.ImageWrapper>)}
      </List>}
    </S.ListOfImages>
  )
}

ListOfImages.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.shape({
      alt: PropTypes.string,
      src: PropTypes.string.isRequired,
      description: PropTypes.string,
    }),
    slug: PropTypes.string,
  })).isRequired
}

export default ListOfImages
